module.exports = __webpack_public_path__ + "media/images/cancel-off-8d15d2220d22eeff459c3de49675a4c7.png";